import { memo, useEffect } from 'react';
import { ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { useAsyncFn } from '@zmedia/bm-soccer-ui/hooks';
import PageService from '@zmedia/bm-soccer-ui/service/PageService';
import { renderSections } from '../../shared/components/sections';
import { GridHome } from '../components';

function HomeView(props: any) {
    let data = props;
    if (ObjectUtils.isEmpty(data)) {
        const [state, callback] = useAsyncFn(PageService.getHome);
        data = state.value?.data || {};

        useEffect(() => {
            callback();
        }, []);
    }

    if (ObjectUtils.isEmpty(data)) {
        return null;
    }

    return (
        <>
            {renderSections(data.sections, {}, props.listProps)}
            <GridHome data={data} listProps={props.listProps} />
        </>
    );
}

export default memo(HomeView);
